import { Persona } from '@fluentui/react';
import { Facepile, Icon, IFacepilePersona, OverflowButtonType, PersonaSize } from 'office-ui-fabric-react';

interface IGridListIconFormat {
  formField: any;
  width?: number;
}

const iconStyles = {
  root: {
    fontWeight: 'bold',
    fontSize: '14px',
  },
};

const GridListIconFormat = (props: IGridListIconFormat) => {
  const format = (formField: any) => {
    if (formField == true) {
      return (
        <span style={{ width: `${props.width}px`, display: 'inline-block' }} className="text-center">
          <Icon iconName="CheckMark" className="color-success" styles={iconStyles} />
        </span>
      );
    } else if (formField == 'dontShow') {
      return <></>;
    } else {
      return (
        <span style={{ width: `${props.width}px`, display: 'inline-block' }} className="text-center">
          <Icon iconName="Cancel" className="color-error" styles={iconStyles} />
        </span>
      );
    }
  };

  return format(props.formField);
};

export default GridListIconFormat;

export const ActiveIconFormat = (isActive: boolean) => {
  return (
    <span>
      <Icon iconName="LocationFill" className={isActive ? 'active-color' : 'inactive-color'}></Icon>
    </span>
  );
};

export const AptoMedicoIconFormat = (isActive: boolean) => {
  return (
    <span>
      <Icon
        iconName={isActive ? 'SkypeCircleCheck' : 'Cancel'}
        className={isActive ? 'active-color' : 'inactive-color'}
      ></Icon>
    </span>
  );
};

export const RamaIconFormat = (gender: string) => {
  return (
    <span>
      <Icon
        iconName="Contact"
        className={gender === 'M' ? 'rama-icon male-icon' : 'rama-icon female-icon'}
        title={gender === 'M' ? 'Masculino' : 'Femenino'}
      ></Icon>
    </span>
  );
};

// Lista de colores predefinidos
// Función para obtener un número de 1 a 24 basado en las iniciales
function getColorIndexFromInitials(initials: string) {
  let hash = 0;

  // Convertir las iniciales a un valor hash
  for (let i = 0; i < initials.length; i++) {
    hash = initials.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Asegurarse de que el valor del hash sea positivo
  hash = Math.abs(hash);

  // Obtener un valor entre 1 y 24
  const colorIndex = (hash % 24) + 1;
  if ((colorIndex >= 20 && colorIndex <= 22) || colorIndex == 15) return 1;
  return colorIndex;
}
export const CategoriaIconFormat = (categoria: string, size?: PersonaSize) => {
  const initials = categoria.slice(0, 3).toLocaleUpperCase();
  const color = getColorIndexFromInitials(categoria);

  const personas: IFacepilePersona[] = [
    {
      imageInitials: initials,
      personaName: categoria,
      data: categoria,
      initialsColor: color, // Asigna el color generado
    },
  ];

  return (
    <span>
      <Facepile
        personas={personas} // Pasamos la lista de personas
        maxDisplayablePersonas={1} // Mostrar solo 1 item
        overflowButtonType={OverflowButtonType.none} // No mostrar botón de desbordamiento
        onRenderPersona={(props) => (
          <Persona
            {...props}
            size={size ? size : PersonaSize.size24}
            onRenderPrimaryText={() => <></>}
          ></Persona>
        )}
      />
    </span>
  );
};
